import React from 'react';
import EditVideoCategoryState from './editVideoCategoryState/editVideoCategoryState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Forms from './components/Forms/Forms';

const EditVideoCategoryPage: React.FC = () => {
	return (
		<EditVideoCategoryState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</EditVideoCategoryState>
	);
};

export default EditVideoCategoryPage;
